import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import VModal from "vue-js-modal";
import Vuelidate from "vuelidate";
import VueTheMask from "vue-the-mask";
import Notifications from "vue-notification";
import Paginate from "vuejs-paginate";
import "./filters/filters";
import "@mdi/font/css/materialdesignicons.css";

import printManifestCSS from "./helpers/printManifestCssString";

import VueHtmlToPaper from "./helpers/print";
import VueCurrencyInput from "vue-currency-input";
import VueCurrencyFilter from "vue-currency-filter";

Vue.use(VueCurrencyFilter, {
  symbol: "R$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
  avoidEmptyDecimals: undefined
});
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: "BRL" }
};
Vue.use(VueCurrencyInput, pluginOptions);

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.2/css/bulma.min.css"
  ],
  localStyles: printManifestCSS.css
};

Vue.use(VueHtmlToPaper, options);

const moment = require("moment");
moment.locale("pt-br", { week: { dow: 1 } });
Vue.use(require("vue-moment"), { moment });

Vue.use(Buefy, {
  defaultDateFormatter: date => {
    return moment(date).format("DD/MM/YYYY");
  },
  defaultMonthNames: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ],
  defaultDayNames: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  defaultIconPack: "mdi"
});

Vue.use(Vuelidate);
Vue.use(VModal, { dynamic: true, dialog: true });
Vue.use(VueTheMask);
Vue.use(Notifications);
Vue.component("paginate", Paginate);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
